import { render, staticRenderFns } from "./classDisplaySetLogs.vue?vue&type=template&id=b1511c46&scoped=true"
import script from "./classDisplaySetLogs.vue?vue&type=script&lang=js"
export * from "./classDisplaySetLogs.vue?vue&type=script&lang=js"
import style0 from "./classDisplaySetLogs.vue?vue&type=style&index=0&id=b1511c46&prod&lang=less"
import style1 from "./classDisplaySetLogs.vue?vue&type=style&index=1&id=b1511c46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1511c46",
  null
  
)

export default component.exports